<script>
import BusinessHours from './fields/TypeBusinessHours'
import Checkbox from './fields/TypeCheckbox'
import Country from './fields/TypeCountry'
import Date from './fields/TypeDate'
import Default from './fields/TypeDefault'
import DisplayImage from './fields/TypeDisplayImage'
import DisplayText from './fields/TypeDisplayText'
import Email from './fields/TypeEmail'
import Img from './fields/TypeImg'
import Password from './fields/TypePassword'
import Phone from './fields/TypePhone'
import Radio from './fields/TypeRadio'
import Range from './fields/TypeRangeSelect'
import Select from './fields/TypeSelect'
import State from './fields/TypeState'
import Switch from './fields/TypeSwitch'
import TextBox from './fields/TypeTextBox'
// import Toggle from './fields/TypeToggle'
import Website from './fields/TypeWebsite'
import Zipcode from './fields/TypeZipcode'
import RedemptionFrequency from './fields/TypeRedemptionFrequency'
import Review from './fields/TypeReview'
import GridSelection from './fields/TypeGridSelection'
import Categories from './fields/TypeCategories'
import GooglePlace from './fields/TypeGooglePlace'
import TemplateSelection from './fields/TypeTemplateSelection'
import GoogleMapPin from "./fields/TypeGoogleMapPin";
import IronCladContract from "./fields/TypeIronCladContract";
import NumberIncrementer from './fields/TypeNumberIncrementer'
import ColorSelector from "./fields/TypeColorSelector";
import Highlights from "./fields/TypeHighlights";
import LanguageTag from "./fields/TypeLanguageTag";
import PIN from "./fields/TypePIN.vue";
import WYSIWYG from "./fields/TypeWYSIWYG";
import Attributes from "./fields/TypeAttributes";
import AttributesVenue from './fields/TypeAttributesVenue';
import Money from "./fields/TypeMoney";
import AlertMessage from "./fields/TypeAlertMessage"
import PreviewLink from "./fields/TypePreviewLink"

// Helpers
import OptionsEditor from './helpers/TypeOptionsEditor'
import Ticket from "./fields/TypeTicket";

export default {
  name: 'FormRenderer',
  functional: true,
  render(h, ctx) {
    function formComponent() {
      const type = ctx.props.type.toLowerCase().split(' ').join('-').trim();

      if (type === 'business-hours') return BusinessHours
      else if (type === 'checkbox' || type === 'check-box') return Checkbox
      else if (type === 'country') return Country
      else if (type === 'date') return Date
      else if (type === 'display-image') return DisplayImage
      else if (type === 'display-text') return DisplayText
      else if (type === 'email') return Email
      else if (type === 'img' || type === 'image') return Img
      else if (type === 'password') return Password
      else if (type === 'phone') return Phone
      else if (type === 'money') return Money
      else if (type === 'radio') return Radio
      else if (type === 'range') return Range
      else if (type === 'select' || type === 'dropdown' || type === 'drop-down') return Select
      else if (type === 'state') return State
      else if (type === 'switch') return Switch
      else if (type === 'text-box' || type === 'text-area') return TextBox
      else if (type === 'wysiwyg') return WYSIWYG
      // else if (type === 'toggle') return Toggle
      else if (type === 'website') return Website
      else if (type === 'zipcode') return Zipcode
      else if (type === 'options-editor') return OptionsEditor
      else if (type === 'redemptionfrequency') return RedemptionFrequency
      else if (type === 'gridselection') return GridSelection
      else if (type === 'review') return Review
      else if (type === 'categories') return Categories
      else if (type === 'googleplace') return GooglePlace
      else if (type === 'googlepin') return GoogleMapPin
      else if (type === 'ironcladcontract') return IronCladContract
      else if (type === 'templateselection') return TemplateSelection
      else if (type === 'numberincrementer') return NumberIncrementer
      else if (type === 'highlights') return Highlights
      else if (type === 'languagetag') return LanguageTag
      else if (type === 'attributes') return Attributes
      else if (type === 'attributesvenue') return AttributesVenue
      else if (type === 'colorselector' || type === 'color-selector') return ColorSelector
      else if (type === 'pin') return PIN
      else if (type === 'alertmessage') return AlertMessage
      else if (type === 'ticket') return Ticket
      else if (type === 'preview-link') return PreviewLink
      else return Default
    }
    return h(formComponent(), ctx.data, ctx.children)
  },
}
</script>
